import { useState, useEffect } from "react";

function Episodes({ ep_api }){
    const [episodeData, setEpisodeData] = useState(null);

    useEffect(() => {
        const fetchEpisode = async () => {
            try {
                const response = await fetch(ep_api);
                const data = await response.json();
                setEpisodeData(data);
            } catch (error) {
                console.error("Error fetching episode data:", error);
            }
        };

        fetchEpisode();
    }, [ep_api]);

    if (!episodeData) {
        return <div>Loading episode...</div>;
    }

    return (
        <div className="episode-item">
            <h4>{episodeData.episode}: {episodeData.name}</h4>
            <p><strong>Air Date:</strong> {episodeData.air_date}</p>
        </div>
    );
}

export default Episodes;